import { i18n } from '@lt/localization';
import React from 'react';
import styled, { css } from 'styled-components';

type CheapestFlightLabelProps = {
  isMobile?: boolean;
  direct: boolean;
};

const CheapestFlightLabel = ({
  isMobile = false,
  direct,
}: CheapestFlightLabelProps): JSX.Element => (
  <Label $isMobile={isMobile}>
    {direct
      ? i18n.t('checkout.flight.cheapestDirectFlightLabel')
      : i18n.t('checkout.flight.cheapestFlightLabel')}
  </Label>
);

const Label = styled.div<{ $isMobile?: boolean }>`
  // Перекрывать бэкграунд перелета без конкретизации
  z-index: 2;
  position: absolute;
  top: -8px;
  border-radius: var(--border-radius);
  background-color: var(--primary);

  color: var(--primary-color);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;

  ${({ $isMobile }) =>
    $isMobile
      ? css`
          right: 7px;
          padding: 5px 10px;
        `
      : css`
          left: 36px;
          padding: 4px 6px;
        `}
`;

export default CheapestFlightLabel;
